import Vue from "vue";
import Component from "vue-class-component";
import { DgText } from "@dasgate/uikit";

@Component({ components: { DgText } })
export default class CredentialExpiredLabel extends Vue {}
